/**
 * @param 1:brand → nombre de la marca
 * @example brands: veci, logitravel, partnerships, partnershipsUniversalMusic, partnershipsPortaventura, partnershipsHolidayguru, smy, smyPassengy.
 * @param 2:ComponenteName → nombre del componente (DestinationCard)
 * @param 3:Device → Desktop/Mobile
 */ import { css } from "styled-components";
import { Button } from "../../../../../../../../base/buttons/button/index.js";
import { Border } from "../../../../../../../../../styles/common/mixins/logical.styled.js";
const veciTabsStyles = {
    ProductCardTab: ()=>css`
		& > li:last-child:before {
			display: none;
		}

		${({ theme  })=>Border({
                bottom: `1px solid ${theme.border.color.light}`
            })}

		${Button} {
			text-transform: capitalize;
			color: ${({ theme  })=>theme.colors.text.light};
			&.is-active {
				color: ${({ theme  })=>theme.colors.text.dark};
				:after {
					position: absolute;
					bottom: -1px;
					content: '';
					width: 100%;
					height: 2px;
					background-color: ${({ theme  })=>theme.colors.primary.base};
				}
			}
		}
	`
};
export default veciTabsStyles;

//# sourceMappingURL=veci.js.map